import { createUseStyles } from 'react-jss'
import { black, lightGrey } from '../../../../../styles/const/colors'
import { defaultBorderRadius, transitionShort } from '../../../../../styles/const/common'
import { fontFamily, fontWeightRegular } from '../../../../../styles/typography'

const useStyles = createUseStyles({
  spendMetricsBlock: {
    width: 202,
    display: 'inline-flex',
    justifyContent: 'space-between',
    marginTop: 15,
    color: black,

    border: {
      width: 2,
      style: 'solid',
      color: lightGrey
    },
    borderRadius: defaultBorderRadius,
    transition: transitionShort,
    fontSize: 14,
    padding: '8px 14px',
    fontWeight: fontWeightRegular,
    fontFamily: fontFamily,
    cursor: 'pointer'
  },
  coinIcon: {
    color: black
  }
})

export default useStyles
